import {
  NotificationProps as MantineNotificationProps,
  Notification as MantineNotification,
} from '@mantine/core';

export type NotificationProps = MantineNotificationProps;

export const Notification = MantineNotification;

Notification.displayName = 'Notification';
